import { TSendRestorePasswordEmailParams } from 'types/services';
import { m8API } from 'services/production/m8';

export const sendRestorePasswordEmail = async (
  params: TSendRestorePasswordEmailParams
) => {
  const { emailAddress } = params;

  await m8API.auth.processForgotPasswordMailForm({ eMail: emailAddress });
};
